<template>
  <div class="wrapper">
    <header>
      <div class="container inner">
        <img src="@/assets/img/centerone/logo.png" alt="img" />
        <p @click="goToInquiry">문의하기</p>
      </div>
    </header>
    <main>
      <Con1></Con1>
      <Con2></Con2>
      <Con3></Con3>
      <Con4></Con4>
      <Con5></Con5>
      <Con6></Con6>
      <Con7></Con7>
      <section class="online-class">
        <div class="container inner">
          <div @click="goToOnlineClass">
            <div class="left">
              <img src="@/assets/img/centerone/book.png" alt="img" />
              <p>멤버십 회원을 위한 온라인 클래스</p>
            </div>
            <div class="right">
              <img src="@/assets/img/centerone/go.png" alt="img" />
            </div>
          </div>
        </div>
      </section>
      <Inquiry></Inquiry>
    </main>
    <Footer></Footer>

    <div class="go-top" @click="goToTop">
      <img src="@/assets/img/centerone/top.png" alt="img" />
    </div>
  </div>
</template>
<script>
import Con1 from "@/components/Centerone/con1.vue";
import Con2 from "@/components/Centerone/con2.vue";
import Con3 from "@/components/Centerone/con3.vue";
import Con4 from "@/components/Centerone/con4.vue";
import Con5 from "@/components/Centerone/con5.vue";
import Con6 from "@/components/Centerone/con6.vue";
import Con7 from "@/components/Centerone/con7.vue";
import Inquiry from "@/components/Centerone/Inquiry.vue";
import Footer from "@/components/Centerone/Footer.vue";

export default {
  components: { Con1, Con2, Con3, Con4, Con5, Con6, Con7, Inquiry, Footer },
  methods: {
    goToInquiry() {
      document
        .getElementById("inqueryTxtArea")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goToOnlineClass() {
      window.open("https://centerone.imooc.co.kr/bmain", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

header,
main {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.wrapper {
  position: relative;
  font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-use-select: none;
  user-select: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

// header
header {
  background-color: #f7f2ec;

  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 47px 18px 18px;

    @media screen and (min-width: 1200px) {
      padding: 38px 18px;
    }

    img {
      width: 134px;

      @media screen and (min-width: 1200px) {
        width: 168px;
      }
    }

    p {
      font-weight: 500;
      color: #3e3e3e;
      cursor: pointer;

      @media screen and (min-width: 1200px) {
        font-size: 20px;
      }
    }
  }
}

// online-class
.online-class {
  padding: 70px 0;

  @media screen and (min-width: 1200px) {
    padding: 150px 0;
  }

  .inner {
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media screen and (min-width: 1200px) {
        padding: 38px;
        border-block: 1px solid #707070;
      }
      cursor: pointer;

      .left {
        display: flex;
        align-items: center;
        gap: 18px;

        img {
          width: 34px;

          @media screen and (min-width: 1200px) {
            width: 56px;
          }
        }

        p {
          font-weight: 700;

          @media screen and (min-width: 1200px) {
            font-size: 30px;
          }
        }
      }

      .right {
        width: 10px;

        @media screen and (min-width: 1200px) {
          width: 18px;
        }
      }
    }
  }
}

// top
.go-top {
  position: fixed;
  bottom: 18px;
  right: 18px;
  width: 46px;
  cursor: pointer;

  @media screen and (min-width: 1200px) {
    bottom: 90px;
    right: 90px;
    width: 80px;
  }
}
</style>
